<template>
  <div>
    <v-container  class="mb-4 pb-0">
      <v-layout wrap>
        <v-flex
          xs12
          lg10
          offset-lg1
          xl8
          offset-xl2
        >
          <h3 class="headline mb-4">Was sind eigentlich <strong>Innungen?</strong> Kurz im Video erklärt:</h3>

        <video-player 
          v-if="showplayer"
          class="mt-4 mb-5 vjs-custom-skin vjs-big-play-centered elevation-24"
          ref="videoPlayer"
          :options="playerOptions"
          :playsinline="true"
          @play="onPlayerPlay($event)"
          @pause="onPlayerPause($event)"
          @ended="onPlayerEnded($event)"
          @loadeddata="onPlayerLoadeddata($event)"
          @waiting="onPlayerWaiting($event)"
          @playing="onPlayerPlaying($event)"
          @timeupdate="onPlayerTimeupdate($event)"
          @canplay="onPlayerCanplay($event)"
          @canplaythrough="onPlayerCanplaythrough($event)"
          @ready="playerReadied"
          @statechanged="playerStateChanged($event)">
        </video-player>
    
    <div v-else class="text-xs-center mb-3">
          <v-progress-circular indeterminate color="accent"></v-progress-circular>
        </div>

        </v-flex>
        <!-- <v-flex xs12 class="text-xs-center mt-3">
          <v-btn large color="accent" class="title text-none" :to="{ name: 'Mitmachen' }">
            Mitmachen
           <v-icon right dark>done_outline</v-icon>
          </v-btn>
        </v-flex> -->
      </v-layout>
    </v-container>

  </div>
</template>

<script>
import 'video.js/dist/video-js.css'
import { videoPlayer } from 'vue-video-player'

export default {
  components: {
    videoPlayer
  },
  data () {
    return {
      showplayer: false,
      playerOptions: {
          // videojs options
        muted: false,
        fluid: true,
        language: 'de',
        volume: 0.3,
        playbackRates: 1,
        sources: [{
          type: 'video/mp4',
          src: '/video/innungen_short_edit.720.mp4'
        }],
        poster: '/img/tmp/innungen_poster.webp'
      }
    }
  },
  mounted () {
      // console.log('this is current player instance object', this.player)
    this.showplayer = true
  },
  computed: {
    player () {
      return this.$refs.videoPlayer.player
    }
  },
  methods: {
      // listen event
    onPlayerPlay (player) {
        // console.log('player play!', player)
    },
    onPlayerPause (player) {
        // console.log('player pause!', player)
    },
    onPlayerEnded (player) {
        // console.log('player ended!', player)
    },
    onPlayerLoadeddata (player) {
        // console.log('player Loadeddata!', player)
    },
    onPlayerWaiting (player) {
        // console.log('player Waiting!', player)
    },
    onPlayerPlaying (player) {
        // console.log('player Playing!', player)
    },
    onPlayerTimeupdate (player) {
        // console.log('player Timeupdate!', player.currentTime())
    },
    onPlayerCanplay (player) {
        // console.log('player Canplay!', player)
    },
    onPlayerCanplaythrough (player) {
        // console.log('player Canplaythrough!', player)
    },
      // or listen state event
    playerStateChanged (playerCurrentState) {
        // console.log('player current update state', playerCurrentState)
    },
      // player is ready
    playerReadied (player) {
        // seek to 10s
      // console.log('example player 1 readied', player)
      player.volume(0.4)
        // console.log('example 01: the player is readied', player)
    }
  }
}

</script>


<style>
.mouseoverlink {
  cursor: pointer;
}
.video-js .vjs-big-play-button .vjs-icon-placeholder:before, .vjs-button > .vjs-icon-placeholder:before, .video-js .vjs-modal-dialog, .vjs-modal-dialog .vjs-modal-dialog-content {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%; }

.video-js .vjs-big-play-button .vjs-icon-placeholder:before, .vjs-button > .vjs-icon-placeholder:before {
  text-align: center; }
</style>